"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBrowser = isBrowser;

var _node = require("./node.js");

var _worldwide = require("./worldwide.js");

/**
 * Returns true if we are in the browser.
 */
function isBrowser() {
  // eslint-disable-next-line no-restricted-globals
  return typeof window !== 'undefined' && (!(0, _node.isNodeEnv)() || isElectronNodeRenderer());
} // Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them


function isElectronNodeRenderer() {
  const process = _worldwide.GLOBAL_OBJ.process;
  return !!process && process.type === 'renderer';
}